@if (showWarningBanner) {
	<div class="app-nav__live-account-banner" [class.app-nav__live-account-banner--shrink]="visuallyCollapsed">
		<span class="app-nav__live-account-text">{{
			(visuallyCollapsed ? "common.liveAccountBannerShrink" : "common.liveAccountBanner") | content
		}}</span>
	</div>
} @else {
	<div class="app-nav__header">
		<a
			class="app-nav__logo"
			routerLink="/{{ routesManager.homePage }}"
			(click)="logAnalyticsEvent(analyticEventsConsts.SIDEBAR_progrees_bar)"
		>
			<img class="app-nav__logo-image" src="assets/img/SVG/mine-os-logo.svg" alt="MineOS" />
		</a>
		<div class="app-nav__header-actions">
			<button class="app-nav__toggle-btn" type="button" (click)="toggle()" [attr.aria-label]="'menu.collapse' | content">
				<i mine-icon name="sidebar" size="s" class="app-nav__toggle-svg"></i>
			</button>
			<app-notifications-bell class="app-nav__bell" [newNav]="true"></app-notifications-bell>
		</div>
	</div>
}

<div class="app-nav__items-wrapper">
	<app-nav-content [shrink]="visuallyCollapsed"></app-nav-content>
</div>

<section class="app-nav__bottom-row">
	<button
		class="app-nav__icon-btn"
		type="button"
		(click)="openChat()"
		[tp]="'app-nav.chat' | content"
		[tpIsEnabled]="visuallyCollapsed"
		[tpPlacement]="tpProps.placement"
	>
		<i mine-icon name="bubble" size="s" class="app-nav__icon"></i>
		<span class="app-nav__icon-text">{{ "app-nav.chat" | content }}</span>
	</button>

	<button
		*minePermissions="whatsNewPermittedRoles"
		class="beamerTrigger app-nav__icon-btn"
		type="button"
		[attr.data-label]="'app-nav.updates' | content"
		[tp]="'app-nav.updates' | content"
		[tpIsEnabled]="visuallyCollapsed"
		[tpPlacement]="tpProps.placement"
	>
		<i mine-icon name="gift" size="s" class="app-nav__icon"></i>
		<span class="app-nav__icon-text">{{ "app-nav.updates" | content }}</span>
	</button>

	<button
		class="app-nav__icon-btn"
		type="button"
		(click)="onHelpClick()"
		[tp]="'app-nav.help' | content"
		[tpIsEnabled]="visuallyCollapsed"
		[tpPlacement]="tpProps.placement"
	>
		<i mine-icon name="book" size="s" class="app-nav__icon"></i>
		<span class="app-nav__icon-text">{{ "app-nav.help" | content }}</span>
	</button>
</section>

<div class="app-nav__divider"></div>

<div class="app-nav__footer">
	<app-menu class="app-nav__user-menu" [flushLabel]="true" [newNav]="true" [collapsed]="visuallyCollapsed"></app-menu>
</div>
